import React, { useState, useEffect } from "react";
import api from "../../api/AxiosAPI";
import Auth from "../../api/Auth";
import { User } from "../../data-models/user";
import { Button, Select } from "semantic-ui-react";
import { Nivel, defaultNivel } from "../../data-models/nivel";
import { defaultSubnivel, Subnivel } from "../../data-models/subnivel";
import { Grupo, defaultGrupo } from "../../data-models/grupo";
import { defaultUnidad, Unidad } from "../../data-models/unidad";
import { paises } from "../../constants/paises";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { alpha } from "@material-ui/core/styles";
import LoadingOverlay from "react-loading-overlay-ts";

function UsuarioAgregar(props: {
  switchScreen: any;
  saveUser: any;
  // niveles: Nivel[];
  // subniveles: Subnivel[];
  // grupos: Grupo[];
  // unidades: Unidad[];
}) {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [pedagogoAsignado, setPedagogoAsignado] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [status, setStatus] = useState("activo");
  const [fechaNacimiento, setFechaNacimiento] = useState<Date | null>(
    new Date()
  );
  const [fechaInscripcion, setFechaInscripcion] = useState<Date | null>(
    new Date()
  );

  const [grupos, setGrupos] = useState([]);
  const [niveles, setNiveles] = useState([]);
  const [subniveles, setSubniveles] = useState([]);
  const [unidades, setUnidades] = useState([]);

  const [gradoInicial, setGradoInicial] = useState("primero");

  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [selectedNivel, setSelectedNivel] = useState("");
  const [selectedSubnivel, setSelectedSubnivel] = useState("");
  const [selectedUnidad, setSelectedUnidad] = useState("");

  const [representante, setRepresentante] = useState("");
  const [pais, setPais] = useState("SV");
  const [showExtraFields, setShowExtraFields] = useState(false);
  const [pedagogos, setPedagogos] = useState([]);
  const [representantes, setRepresentantes] = useState([]);
  const [meta, setMeta] = useState("");
  const [loading, setLoading] = useState(false);

  const { formContainer } = styles;

  useEffect(() => {
    getPedagogos();
  }, []);

  const submit = () => {
    let newUser: User;
    console.log("grupo");
    console.log(selectedGrupo);
    if (
      selectedGrupo === "usuario_activo" ||
      selectedGrupo === "usuario_pasivo"
    ) {
      let fechaInscripcionTimestamp = fechaInscripcion!.getTime();
      let fechaNacimientoTimestamp = fechaNacimiento!.getTime();

      newUser = {
        nombre: nombre,
        apellido: apellido,
        email: email.replace(/\s+/g, "").toLocaleLowerCase(),
        fechaInscripcion: fechaInscripcionTimestamp,
        fechaNacimiento: fechaNacimientoTimestamp,
        gradoInicial: gradoInicial,
        grupo: selectedGrupo,
        nivel: selectedNivel,
        subnivel: selectedSubnivel,
        unidad: selectedUnidad,
        pais: pais,
        pedagogoAsignado: pedagogoAsignado,
        representante: representante,
        status: status,
        telefono: telefono,
        meta: meta,
        guias: [],
      };
    } else {
      newUser = {
        nombre: nombre,
        apellido: apellido,
        email: email.replace(/\s+/g, ""),
        grupo: selectedGrupo,
        pais: pais,
        status: status,
        telefono: telefono,
        guias: [],
        asignaciones: [],
      };
    }

    console.log("test");
    console.log("new user");
    console.log(newUser);
    props.saveUser(newUser);
  };

  const getPedagogos = () => {
    setLoading(true);
    api({
      method: "get",
      url: "/usuarios/FilterUsersByGrupo?grupo=pedagogo",
      headers: { Authorization: Auth.getToken() },
    })
      .then((response) => {
        console.log("response");
        console.log(response);
        setLoading(false);
        if (response.data[0]) {
          setPedagogos(response.data);
        }

        getRepresentantes();
      })
      .catch((error) => {
        setLoading(false);
        console.error("ERROR");
        console.log(error);
        if (error.response) {
          if (error.response.status === 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  const getRepresentantes = () => {
    setLoading(true);
    api({
      method: "get",
      url: "/usuarios/FilterUsersByGrupo?grupo=representante",
      headers: { Authorization: Auth.getToken() },
    })
      .then((response) => {
        setLoading(false);
        console.log("response");
        console.log(response);
        if (response.data[0]) {
          setRepresentantes(response.data);
        }

        getAllGrupos();
      })
      .catch((error) => {
        setLoading(false);
        console.error("ERROR");
        console.log(error);
        if (error.response) {
          if (error.response.status === 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  const generateExtraFields = () => {
    console.log("generate extra fields");
    let extraFields;
    if (!showExtraFields) {
      return extraFields;
    }

    extraFields = (
      <div>
        <div className="five fields">
          <div className="field">
            <label>Fecha de inscripción</label>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                disableFuture
                openTo="year"
                format="dd/MM/yyyy"
                views={["year", "month", "date"]}
                value={fechaInscripcion}
                onChange={(e) => setFechaInscripcion(e)}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div className="field">
            <label>Fecha de nacimiento</label>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                disableFuture
                openTo="year"
                format="dd/MM/yyyy"
                views={["year", "month", "date"]}
                value={fechaNacimiento}
                onChange={(e) => setFechaNacimiento(e)}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div className="field">
            <label>Grado escolar inicial</label>
            <select
              onChange={(e) => setGradoInicial(e.target.value)}
              className="ui dropdown"
            >
              <option key={"kinder"} value={"kinder"}>
                Kinder
              </option>
              <option key={"preparatoria"} value={"preparatoria"}>
                Preparatoria
              </option>
              <option key={"primero"} value={"primero"}>
                Primero
              </option>
              <option key={"segundo"} value={"segundo"}>
                Segundo
              </option>
              <option key={"tercero"} value={"tercero"}>
                Tercero
              </option>
              <option key={"cuarto"} value={"cuarto"}>
                Cuarto
              </option>
              <option key={"quinto"} value={"quinto"}>
                Quinto
              </option>
              <option key={"sexto"} value={"sexto"}>
                Sexto
              </option>
              <option key={"septimo"} value={"septimo"}>
                Septimo
              </option>
              <option key={"octavo"} value={"octavo"}>
                Octavo
              </option>
              <option key={"noveno"} value={"noveno"}>
                Noveno
              </option>
              <option key={"decimo"} value={"decimo"}>
                Décimo
              </option>
              <option key={"onceavo"} value={"onceavo"}>
                Onceavo
              </option>
            </select>
          </div>
          <div className="field">
            <label>Nivel inicial</label>
            <select
              onChange={(e) => setSelectedNivel(e.target.value)}
              className="ui dropdown"
            >
              {niveles.map((nivel) => (
                <option key={nivel.id} value={nivel.nombre}>
                  {nivel.descripcion}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Subnivel</label>
            <select
              onChange={(e) => setSelectedSubnivel(e.target.value)}
              className="ui dropdown"
            >
              {subniveles.map((subnivel) => (
                <option key={subnivel.id} value={subnivel.nombre}>
                  {subnivel.descripcion}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="four fields">
          <div className="field">
            <label>Representante</label>
            <select
              onChange={(e) => setRepresentante(e.target.value)}
              className="ui dropdown"
            >
              {representantes.map((representante) => (
                <option
                  key={representante.id}
                  value={representante.nombre + " " + representante.apellido}
                >
                  {representante.nombre + " " + representante.apellido}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Unidad</label>
            <select
              onChange={(e) => setSelectedUnidad(e.target.value)}
              className="ui dropdown"
            >
              {unidades.map((unidad) => (
                <option key={unidad.id} value={unidad.nombre}>
                  {unidad.descripcion}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Pedagogo asignado</label>
            <select
              onChange={(e) => setPedagogoAsignado(e.target.value)}
              className="ui dropdown"
            >
              {pedagogos.map((pedagogo) => (
                <option
                  key={pedagogo.id}
                  value={pedagogo.nombre + " " + pedagogo.apellido}
                >
                  {pedagogo.nombre + " " + pedagogo.apellido}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Meta</label>
            <input
              onChange={(e) => setMeta(e.target.value)}
              type="text"
              value={meta}
              placeholder="Meta"
            ></input>
          </div>
        </div>
      </div>
    );
    return extraFields;
  };

  const selectGrupo = (selection: string) => {
    // const found = grupos.find((g: Grupo) => g.nombre > selection);

    setSelectedGrupo(selection);
    switch (selection) {
      case "usuario_activo":
        setShowExtraFields(true);
        break;
      case "usuario_pasivo":
        setShowExtraFields(true);
        break;
      default:
        setShowExtraFields(false);
        break;
    }
  };

  const selectNivel = (selection: string) => {
    const found = niveles.find((n: Nivel) => (n.nombre = selection));
    setSelectedNivel(found);
  };

  const selectSubnivel = (selection: string) => {
    const found = subniveles.find((n: Subnivel) => (n.nombre = selection));
    setSelectedSubnivel(found);
  };

  const selectUnidad = (selection: string) => {
    const found = unidades.find((n: Unidad) => (n.nombre = selection));
    setSelectedUnidad(found);
  };

  const getAllGrupos = () => {
    let fetchGrupos: Grupo[];
    fetchGrupos = [];
    setLoading(true);
    api({
      method: "get",
      url: "grupos/GetAllGrupos",
      headers: {
        Authorization: Auth.getToken(),
      },
    })
      .then((response) => {
        setLoading(false);
        for (var i in response.data) {
          let grupo = response.data[i];
          fetchGrupos.push({
            id: grupo.id,
            nombre: grupo.nombre,
            descripcion: grupo.descripcion,
          });
        }
        setGrupos(fetchGrupos);
        getAllNiveles();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response) {
          if (error.response.status == 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  const getAllNiveles = () => {
    let fetchNiveles: Nivel[];
    fetchNiveles = [];
    setLoading(true);
    api({
      method: "get",
      url: "niveles/GetAllNiveles",
      headers: {
        Authorization: Auth.getToken(),
      },
    })
      .then((response) => {
        setLoading(true);
        // console.log('Niveles');
        // console.log(response.data);
        for (var i in response.data) {
          let nivel = response.data[i];
          fetchNiveles.push({
            id: nivel.id,
            nombre: nivel.nombre,
            descripcion: nivel.descripcion,
          });
        }
        setNiveles(fetchNiveles);
        getAllSubniveles();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response) {
          if (error.response.status === 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  const getAllSubniveles = () => {
    // console.log('getting subniveles');
    let fetchSubniveles: Subnivel[];
    fetchSubniveles = [];
    setLoading(true);
    api({
      method: "get",
      url: "subniveles/GetAllSubniveles",
      headers: {
        Authorization: Auth.getToken(),
      },
    })
      .then((response) => {
        setLoading(false);
        // console.log('subniveles');
        // console.log(response.data);
        for (var i in response.data) {
          let subnivel = response.data[i];
          fetchSubniveles.push({
            id: subnivel.id,
            nombre: subnivel.nombre,
            descripcion: subnivel.descripcion,
          });
        }
        setSubniveles(fetchSubniveles);
        getAllUnidades();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response) {
          if (error.response.status == 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  const getAllUnidades = () => {
    let fetchUnidades: Unidad[];
    fetchUnidades = [];
    setLoading(true);
    api({
      method: "get",
      url: "unidades/GetAllUnidades",
      headers: {
        Authorization: Auth.getToken(),
      },
    })
      .then((response) => {
        // console.log('Unidades');
        // console.log(response.data);
        setLoading(false);
        for (var i in response.data) {
          let unidad = response.data[i];
          fetchUnidades.push({
            id: unidad.id,
            nombre: unidad.nombre,
            descripcion: unidad.descripcion,
          });
        }
        setUnidades(fetchUnidades);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response) {
          if (error.response.status === 401) {
            alert("Sesion ha expirado. Favor salir y volver a entrar");
          }
        } else {
          console.log("error, you messed up");
        }
      });
  };

  return (
    <LoadingOverlay active={loading} spinner text="Cargando...">
      <div>
        <Button
          onClick={() => props.switchScreen("usuarios")}
          className="ui primary button"
        >
          Regresar
        </Button>
        <div style={formContainer}>
          <form className="ui form">
            <div className="three fields">
              <div className="field">
                <label>Nombre</label>
                <input
                  onChange={(e) => setNombre(e.target.value)}
                  type="text"
                  placeholder="Primer Nombre"
                ></input>
              </div>
              <div className="field">
                <label>Apellido</label>
                <input
                  onChange={(e) => setApellido(e.target.value)}
                  type="text"
                  placeholder="Apellido"
                ></input>
              </div>
              <div className="field">
                <label>Pais</label>
                <select
                  onChange={(e) => setPais(e.target.value)}
                  className="ui dropdown"
                >
                  {paises.map((pais) => (
                    <option key={pais.code} value={pais.code}>
                      {pais.text}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="four fields">
              <div className="field">
                <label>Email</label>
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  type="text"
                  placeholder="john@doe.com"
                ></input>
              </div>
              <div className="field">
                <label>Teléfono</label>
                <input
                  onChange={(e) => setTelefono(e.target.value)}
                  type="text"
                  placeholder="22222222"
                ></input>
              </div>
              <div className="field">
                <label>Grupo</label>
                <select
                  onChange={(e) => selectGrupo(e.target.value)}
                  className="ui dropdown"
                >
                  {grupos.map((grupo) => (
                    <option key={grupo.id} value={grupo.nombre}>
                      {grupo.descripcion}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {generateExtraFields()}
            <input
              className="ui button"
              type="button"
              onClick={() => submit()}
              value="Guardar"
            />
          </form>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const styles = {
  container: {
    margin: 20,
  },
  formContainer: {
    marginTop: 20,
  },
};

export default UsuarioAgregar;
